import * as React from 'react';

import { PageSeoInfo } from 'components';
import { useCatalogAction, useCatalogValue } from 'context';

const CatalogSeoInfo = () => {
  const { defaultTitle, seo, ownerType } = useCatalogValue();
  const action = useCatalogAction();

  return (
    <PageSeoInfo
      seo={seo}
      ownerType={ownerType}
      defaultName={defaultTitle}
      onUpdateSeoInfo={result => {
        action({
          type: 'UPDATE_CATALOG_SEO',
          payload: {
            seo: result,
          },
        });
      }}
    />
  );
};

export { CatalogSeoInfo };
